import { useState } from 'react';

// styles
import {
  SessionTitle,
  ListContainer,
  ContentItem,
  Title,
  Paragraph,
  PageWrapper,
  CustomContainer,
  CollapseTrigger,
} from './ContentCollapse.styles';

export function ContentCollapse({ content }) {
  const [indexActive, setIndexActive] = useState(0);

  return (
    <PageWrapper>
      <CustomContainer>
        {content.title && <SessionTitle>{content.title}</SessionTitle>}
        {content.items.length != 0 && (
          <ListContainer
            className={content.items.length > 1 ? `` : `single-column`}
          >
            {content.items.map((item, key) => {
              const rKey = `sidepanel-${key}`;
              return (
                <ContentItem
                  key={rKey}
                  className={indexActive === key ? `collapsed` : ``}
                >
                  <CollapseTrigger
                    onClick={() => {
                      setIndexActive(key);
                    }}
                  >
                    <Title>{item.title} </Title>
                  </CollapseTrigger>
                  <Paragraph>{item.text}</Paragraph>
                </ContentItem>
              );
            })}
          </ListContainer>
        )}
      </CustomContainer>
    </PageWrapper>
  );
}
